module.exports = __webpack_public_path__ + "static/media/sot-xuat-huyet.06e6a6c1.jpg";